// removed by extract-text-webpack-plugin
module.exports = {"dropdown":"dropdown","expand-to-right":"expand-to-right","dropdown-menu":"dropdown-menu","expand-to-up":"expand-to-up"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/DropdownButton/DropdownButton.scss
// module id = ju7V
// module chunks = 0